import { Tooltip } from '@systemeio/ui'
import { useEffect, useRef } from 'react'
import { usePagination } from 'shared/route-query/hooks/use-pagination'
import { twMerge } from 'tailwind-merge'
import { useNotifications } from '../hooks/use-notifications'
import UnreadIndicator from './unread-indicator'
import { useOpenNotificationMenuQuery } from '../hooks/use-open-notification-menu-query'
import { BellIcon } from '@systemeio/ui'
import { useActualHeaderLayoutType } from 'shared/components/header'
import { NotificationsMenuContent } from './notifications-menu-content'

export interface NotificationMenuProps {
  className?: string
}

const defaultFilter = {
  onlyUnRead: false,
}

export const NotificationMenu = ({ className }: NotificationMenuProps) => {
  const menuRef = useRef<HTMLButtonElement>(null)
  const menuWasOpenByQueryRef = useRef(false)

  const { pagination } = usePagination(true)
  const { notificationsMeta } = useNotifications({
    shouldFetchNotifications: false,
    limit: 3,
    pagination,
    filter: defaultFilter,
  })

  const { isDesktop } = useActualHeaderLayoutType()
  const { openThroughQuery, setOpenThroughQuery } = useOpenNotificationMenuQuery({
    allowCheck: isDesktop === true,
  })

  useEffect(() => {
    if (openThroughQuery) {
      menuRef.current?.click()
    }
  }, [openThroughQuery])

  const closeMenuOnUnfocusIfOpenedThroughQuery = (isShown: boolean) => {
    setTimeout(() => {
      menuWasOpenByQueryRef.current && !isShown && openThroughQuery && setOpenThroughQuery(false)

      menuWasOpenByQueryRef.current = isShown && openThroughQuery
    })
  }

  return (
    <>
      <Tooltip
        popoverButtonRef={menuRef}
        mode={openThroughQuery ? 'click' : undefined}
        anchor={{
          gap: 13,
          to: 'top end',
          offset: 135,
        }}
        className={className}
        stayOnHover={true}
        popoverClassName={'p-0 shadow-lg rounded-lg'}
        wrapperClassName={'h-full'}
        label={<NotificationsMenuContent className="w-[500px] rounded-lg" />}
      >
        {show => {
          closeMenuOnUnfocusIfOpenedThroughQuery(show)

          return (
            <div className="focus-visible:border-brand-primary focus:outline-hidden flex h-full items-center justify-around gap-2.5 border-b-4 border-transparent">
              <div className="text-background-secondary/90 relative w-5 text-sm font-bold">
                <BellIcon
                  className={twMerge(
                    'fill-background-tertiary stroke-background-tertiary hover:fill-background-secondary hover:stroke-background-secondary w-4 transition',
                    show && 'fill-background-secondary stroke-background-secondary',
                  )}
                />
                {notificationsMeta?.hasUnread && (
                  <UnreadIndicator
                    className="absolute right-0 top-0 p-0 "
                    iconClassName="w-2 h-2"
                  />
                )}
              </div>
            </div>
          )
        }}
      </Tooltip>
    </>
  )
}
